import type { ReactElement } from 'react';

import { PlusPaywall } from 'app/shared-components/PlusPaywall';

export default function SuperLinksPaywall(): ReactElement {
  return (
    <PlusPaywall
      title="See which of your marketing brings patients in"
      description="Superlinks are custom deep links that take patients straight to a service, product or condition in your pharmacy app. Share them anywhere and track how each one performs."
      benefits={[
        'Link to anything in your app.',
        'Conversion tracking. See total clicks, unique clicks and conversions.',
        'Share them easily as links or QR codes',
      ]}
      image={{ src: '/assets/images/plus-paywall/super-links.webp' }}
    />
  );
}
